module.exports = __webpack_public_path__ + "static/media/background__platform--1.8d512494.png";